import { UITab } from '@constants';
import React, { memo, useMemo, useState, useRef } from 'react';
import trans from 'translation';
import { KContainer, KTab, KTabInstance } from 'uikit';

import WaitingTime from './components/STCWaitingTime';
// import TripSummary from './components/TripSummary';

const WaitingTrip = () => {
  const tabRef = useRef<KTabInstance>(null);
  const [tabIndex, setTabIndex] = useState(0);

  const mainTabs = useMemo(
    () => [
      {
        code: UITab.WaitingTime,
        label: trans('waiting_time')
      },
      {
        code: UITab.TripSummary,
        label: trans('trip_summary')
      }
    ],
    []
  );

  return (
    <>
      <KContainer.Card>
        <KContainer.View>
          <KTab.White
            marginB="0.5rem"
            marginT={0}
            // @ts-ignore
            marginH={-16}
            height={40}
            ref={tabRef}
            tabIndex={tabIndex}
            onChangeTab={setTabIndex}
            tabs={mainTabs}
          />
        </KContainer.View>
      </KContainer.Card>

      <KContainer.View>
        {tabIndex === 0 && <WaitingTime />}
        {/* {tabIndex === 1 && <TripSummary />} */}
      </KContainer.View>
    </>
  );
};

export default memo(WaitingTrip);
